export default "__VITE_ASSET__C2njzja3__"